import Vue from "vue";
import Router from "vue-router";
import { HomeView } from "@/modules";
import { authRoutes } from "@/modules/auth/routes";
import { adminRoutes } from "@/modules/admin/routes";
import { questionnaireRoutes } from "@/modules/questionnaire/routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: HomeView,
    },
    ...authRoutes,
    ...adminRoutes,
    ...questionnaireRoutes,
    // { LEFT THIS HERE JUST FOR A SAMPLE OF HOW TO LAZY LOAD ROUTES
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ "./views/About.vue"),
    // },
  ],
});

router.beforeEach((to, from, next) => {
  const allowAnonymous = to.matched.some(record => record.meta.allowAnonymous);
  const isAuthenticated = router.app.$auth.isAuthenticated();

  if (!allowAnonymous) {
    if (!isAuthenticated) {
      // If a non-anonymous route and user not authenticated, redirect to login
      next("login");
      return;
    }
    // If non-anonymous route and user authenticated, don't do anything
  } else {
    if (isAuthenticated) {
      // if anonymous route, and user authenticated, redirect to home, don't want to bother the user
      next("home");
      return;
    }
  }

  if (isAuthenticated && !to.name) {
    // transition to a route without name means that the route has not been recognized. Check the spelling of the route.
    next("home");
    return;
  }

  next();
});

export default router;
